var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",attrs:{"width":_vm.size,"height":_vm.size}},[_c(_vm.icon,{key:_vm.name,tag:"component",attrs:{"size":_vm.size,"fill-color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }